import { addSharingLink } from '../actions/internalActions';
import { deleteLink, sharingLinkRemoved } from '../actions/subscribableActions';
import getStore from '../store/store';
import { mutator } from 'satcheljs';

mutator(addSharingLink, actionMessage => {
    const store = getStore();
    store.sharingLinks.set(actionMessage.linkId, actionMessage.linkModel);
});

mutator(sharingLinkRemoved, actionMessage => {
    const store = getStore();
    store.sharingLinks.delete(actionMessage.linkId);
});

mutator(deleteLink, actionMessage => {
    const store = getStore();
    store.sharingLinks.delete(actionMessage.linkId);
});
